// extracted by mini-css-extract-plugin
export default {"external-document-message":"styles_external-document-message__bR8kJ"};